import { api } from '../index.js'

export default {
  namespaced: true,

  state: {
    applications: []
  },

  mutations: {
    updateApplications(state, applications) {
      state.applications = applications
    },

    resetApplications(state) {
      state.applications = []
    }
  },

  actions: {
    async fetchAll({ commit, state }) {
      let [applications] = await api.applications.all()
      commit('updateApplications', applications)
    },

    async search({ commit, state }, { query, campaign = false }) {
      let [applications] = await api.applications.search(query, campaign)
      commit('updateApplications', applications)
    }
  }
}
